import { Navigate } from 'react-router'

export function ProtectedRoute({
  element,
  condition,
}: {
  element: React.ReactElement
  condition: boolean
}) {
  return condition ? element : <Navigate to='/' replace />
}
